export const EDU_ADS_DEFAULT = 'edu-a-default';

export enum AdTags {
  Edx = 'edx',
  ArtIntel = 'art-intel',
  Counseling = 'counseling',
  Bootcamp = 'bootcamps',
  Accounting = 'accounting',
  BoardingSchools = 'boarding-schools',
  Business = 'business',
  SocialWork = 'social-work',
  Education = 'education',
  Nursing = 'nursing',
  ComputerScience = 'comp-sci',
  Analytics = 'analytics',
  Cybersecurity = 'cyber',
  DataScience = 'data-science',
  ExecutiveEducation = 'executive-education',
  Psychology = 'psychology',
  PublicHealth = 'public-health',
  DigitalMarketingBootcamp = 'digitalmarketing-bootcamp',
  UiuxBootcamp = 'uxui-bootcamp',
  CyberBootcamp = 'cyber-bootcamp',
  DataBootcamp = 'data-bootcamp',
  CodingBootcamp = 'coding-bootcamp',
  Default = 'edu-a-default',
  DefaultSchool = 'edu-s-default',
  NoAds = 'No Ads',
  NoOutbrain = 'no-outbrain',
  NoVideoAds = 'No Video Ads',
  NoRecirculationModules = 'No Recirculation Modules',
  NoTrinityAds = 'No Trinity Ads',
  NoLatestNews = 'No Latest News',
  NoMostPopularNews = 'No Most Popular News',
}
